import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await exchangeGoogleSession(session_id);
        // Clear the hash so it isn't re-processed on next mount
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${user.name}`);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-2 border-[#111827] border-t-transparent animate-spin" />
        <p className="mt-4 label-eyebrow text-[#4B5563]">Signing you in</p>
      </div>
    </div>
  );
}
